
<script>
import IndividualizationAdd from './IndividualizationAdd'
export default {
  name: 'socialWechatIndividualizationDetail',
  extends: IndividualizationAdd
}
</script>
